import { useMemo, useState } from 'react';
// Bar Table Master — dedicated to the Bar module. Reads service_tables +
// bar_table_qr via /api/v1/bar/masters/tables. Completely separate from the
// KOT table master per user directive 2026-04-24.
// Legacy TableMaster kept imported (eslint-disable) for quick rollback.
// eslint-disable-next-line no-unused-vars
import TableMaster from './TableMaster';
import BarTableMaster from './BarTableMaster';
import StoreMaster from './StoreMaster';
import UomMaster from './UomMaster';
import LiquorCategory from './LiquorCategory';
import ItemMaster from './ItemMaster';
import MenuSetup from './MenuSetup';
import BarBillingInfo from './BarBillingInfo';
import BarPromotionsMaster from './BarPromotionsMaster';
// Bar Offer Engine — separate from KOT's offer module (see docs/SRS_BAR_OFFER_ENGINE.md).
// Reads bar's sellable menu from menu_item_setup (/api/menu-setup) and saves via
// /api/v1/bar/masters/offers. Replaces the prior KotOfferMaster mirror.
import BarOfferMaster from './BarOfferMaster';

function BarMastersHub({ token, selectedPropertyId }) {
  const tabs = useMemo(() => ([
    { key: 'table', label: 'Table', render: () => <BarTableMaster token={token} selectedPropertyId={selectedPropertyId} /> },
    { key: 'store', label: 'Store', render: () => <StoreMaster token={token} selectedPropertyId={selectedPropertyId} /> },
    { key: 'uom', label: 'UOM', render: () => <UomMaster token={token} /> },
    { key: 'liquor', label: 'Liquor Category', render: () => <LiquorCategory token={token} selectedPropertyId={selectedPropertyId} /> },
    { key: 'item', label: 'Item Master', render: () => <ItemMaster token={token} selectedPropertyId={selectedPropertyId} /> },
    { key: 'menu', label: 'Menu Setup', render: () => <MenuSetup token={token} /> },
    { key: 'promotions', label: 'Promotions', render: () => <BarPromotionsMaster token={token} selectedPropertyId={selectedPropertyId} /> },
    { key: 'offer', label: 'Offers (Self-Order)', render: () => <BarOfferMaster token={token} selectedPropertyId={selectedPropertyId} /> },
    { key: 'billing', label: 'Billing Info', render: () => <BarBillingInfo token={token} selectedPropertyId={selectedPropertyId} /> }
  ]), [token, selectedPropertyId]);

  const [activeTab, setActiveTab] = useState('table');
  const currentTab = tabs.find((t) => t.key === activeTab) || tabs[0];

  return (
    <div className="page-shell">
      <h2 style={{ color: 'var(--theme-primary-dark)', marginBottom: '0.75rem' }}>BAR - Masters</h2>
      <div style={{ display: 'flex', gap: '0.45rem', flexWrap: 'wrap', borderBottom: '1px solid #dcdde1', paddingBottom: '0.55rem', marginBottom: '0.8rem' }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '0.42rem 0.8rem',
              borderRadius: '6px',
              border: '1px solid #dcdde1',
              cursor: 'pointer',
              background: tab.key === currentTab.key ? 'var(--theme-accent)' : '#fff',
              color: tab.key === currentTab.key ? '#fff' : 'var(--theme-primary-dark)',
              fontWeight: 700
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{currentTab.render()}</div>
    </div>
  );
}

export default BarMastersHub;
